import { ThemeProvider } from "@mui/material";
import Routing from "./components/Routing";

import GraphQLProvider from "./components/GraphQLProvider";

import { customTheme } from "./assets/themes/MUI-override/customTheme";
import Loading from "./components/common/Loading/Loading";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  return (
    <ThemeProvider theme={customTheme}>
      <Loading />
      <ToastContainer position="bottom-right" autoClose={2000} />
      <GraphQLProvider>
        <Routing />
      </GraphQLProvider>
    </ThemeProvider>
  );
};

export default App;
